module.exports = __webpack_public_path__ + "static/media/empty_state_claim.0db47a8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/empty_state_claim.svg
// module id = 938
// module chunks = 0